import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import { ValidateCaptcha } from "@/entity/message";

export class MessageService extends BaseService<any, any, any, any> {
    public async validateCaptcha(params: ValidateCaptcha): Promise<{ code: string; data: boolean }> {
        return await this.service.post(`${this.path}/captcha/send`, params);
    }

    public async sendPhoneCode(mobile: string): Promise<Record<string, unknown>> {
        return await this.service.get(`${this.path}/msg/send?mobile=${mobile}`);
    }
}

export const messageService = new MessageService("", request.service);
